const { REACT_APP_API_URL = '' } = process.env

export const NAMESPACE = 'wallet'

export const ENDPOINTS = {
  BALANCE: `${REACT_APP_API_URL}/wallet/:partyId/balances`,
  PAYOUT: `${REACT_APP_API_URL}/wallet/payout`,
  WITHDRAW: `${REACT_APP_API_URL}/wallet/party/:partyId/transactional/payout`,
  CONSOLIDATED_WITHDRAW: `${REACT_APP_API_URL}/wallet/party/:partyId/consolidated/payout`,
  PAYMENTS: `${REACT_APP_API_URL}/wallet/payments_history`,
  APPROVED_PAYMENTS: `${REACT_APP_API_URL}/reconciliations/payments/approved`,
  REVERSE: `${REACT_APP_API_URL}/wallet/payments/reverse`,
  DEMAND: `${REACT_APP_API_URL}/wallet/payments/demand`,
  TRANSFER: `${REACT_APP_API_URL}/wallet/accounts/:partyId/transfer`,
  WALLET_TRANSFER: `${REACT_APP_API_URL}/wallet/transfer`,
  BULK_WALLET_TRANSFER: `${REACT_APP_API_URL}/wallet/bulk_wallet_transfer/:fromWalletRef`,
  CREATE_WALLET: `${REACT_APP_API_URL}/wallet/create`,
  REFUND: `${REACT_APP_API_URL}/wallet/accounts/:partyId/refund`,
  POP: `${REACT_APP_API_URL}/wallet/request_pop`,
  GET_UNALLOCATED_SUSPENSE_ACCOUNTS: `${REACT_APP_API_URL}/wallet/bad_references`,
  GET_ALLOCATED_SUSPENSE_ACCOUNTS: `${REACT_APP_API_URL}/wallet/bad_references/allocated`,
  ALLOCATE_SUSPENSE_ACCOUNT: `${REACT_APP_API_URL}/wallet/bad_references/:txId`,
  SAVE_SUSPENSE_NOTE: `${REACT_APP_API_URL}/wallet/bad_references/:txId/notes`,
  REFERENCE_LOOKUP: `${REACT_APP_API_URL}/wallet/reference/:reference`,
  BANKS: `${REACT_APP_API_URL}/wallet/banks`,
}

/**
 * Pause between background refreshes of the payments screen while a row is still moving.
 * Recon approvals reach the wallet within seconds and queued payments go out on the
 * wallet's own schedule, so 30s is close enough without hammering two services.
 */
export const PAYMENTS_AUTO_REFRESH_INTERVAL = 30_000

/** The API rejects longer suspense notes, measured after trimming. */
export const SUSPENSE_NOTE_MAX_LENGTH = 2000

export const transferReasons = {
  unsettledInvoice: 'UnsettledInvoice',
  damageClaim: 'DamageClaim',
  leaseEnding: 'LeaseEnding',
  other: 'Other',
}

export const assets = {
  dummy: 'zar_dummy#phoenix.coin',
  zar: 'zar#phoenix.coin',
}
